import person1 from "../../../../assets/images/team/person1.png";
import person2 from "../../../../assets/images/team/person2.png";
import person3 from "../../../../assets/images/team/person3.png";
import logo from "../../../../assets/images/header_images/logo.png";

export const enterpriseMapper = {
    title: "Empresa",
    sectionTitle: {
        line1: "Inovação",
        line2: "em Tecnologia",
    },
    description: "Somos uma empresa emergente em TI, especializada em Análise de Dados e Desenvolvimento de Software. Com uma equipe qualificada, oferecemos soluções personalizadas para transformar dados em insights, atendendo às necessidades específicas dos clientes.",
    banner: {
        title: "Tridimensional",
        description: "Nascida da união de três colegas de faculdade que compartilhavam a mesma visão de colocar o conhecimento em prática para aprimorar os processos de TI nas empresas, a BeTre se dedica a oferecer soluções inovadoras e eficientes que impulsionam a transformação digital. Mais do que desenvolver tecnologia, atuamos como parceiros estratégicos, ajudando negócios de diferentes segmentos a evoluir com confiança e resultados concretos.",
        members: {
            images: [
                { id: 'person1', src: person1, alt: 'Membro da equipe 1' },
                { id: 'person2', src: person2, alt: 'Membro da equipe 2' },
                { id: 'person3', src: person3, alt: 'Membro da equipe 3' },
            ],
            names: "Luis Rosa, Allan Ferreira e Matheus Rodrigues",
        },
        logo: {
            src: logo,
            alt: "Logo BeTre",
        },
    },
};
